import React from 'react'
import { useParams } from 'react-router-dom'

function ClinicDetailsPage() {
    const {clinicId} = useParams();
    return (
        <div>ClinicDetailsPage clinic id {clinicId}</div>
    )
}

export default ClinicDetailsPage